import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinSolid = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.25024 4.25C9.25024 3.05469 10.2168 2 11.4594 2H29.1329C30.3066 2 31.3421 3.05469 31.3421 4.25C31.3421 5.51562 30.3066 6.5 29.1329 6.5H27.0618L27.8212 16.9766C30.3756 18.3828 32.3777 20.7031 33.3442 23.5859L33.4132 23.7969C33.6203 24.5 33.5513 25.2734 33.1371 25.8359C32.7229 26.3984 32.0325 26.75 31.3421 26.75H9.25024C8.49083 26.75 7.86949 26.4688 7.45527 25.8359C6.97201 25.2734 6.90297 24.5 7.11008 23.7969L7.17912 23.5859C8.14564 20.7031 10.1477 18.3828 12.7021 16.9766L13.4615 6.5H11.4594C10.2168 6.5 9.25024 5.51562 9.25024 4.25ZM18.087 29H22.5054V35.75C22.5054 37.0156 21.4698 38 20.2962 38C19.0535 38 18.087 37.0156 18.087 35.75V29Z" })
});
export default SvgPinSolid;
